<div *ngIf="viewInitializationCompleted"
     id="officeHomeRoot"
     [ngClass]="themeRootCssClass">
    <div id="officeHome"
         class="ms-fontWeight-regular ms-bgc-nla"
         [ngClass]="officeHomeClass">
        <div *ngIf="leftNavReact && !onWacContentPage">
            <ng-container ohpLazyView ngModulePath="left-nav-react#LeftNavReactModule"></ng-container>
        </div>
        <div *ngIf="appBarEnabled && !onWacContentPage">
            <div class="ms-bgc-d appbar-placeholder"></div>
            <ng-container ohpLazyView ngModulePath="appbar#AppBarModule"></ng-container>
        </div>
        <router-outlet name="install-wizard"></router-outlet>
        <ng-container ohpLazyView ngModulePath="pull-to-refresh#PullToRefreshModule"
                      *ngIf="pullToRefreshEnabled"
                      [inputs]="{ scrollElement: scrollElement }">
        </ng-container>
        <ng-container *ngIf="loadFeatureCalloutModule" ohpLazyView ngModulePath="feature-callout#FeatureCalloutModule"></ng-container>
        <div id="officeHome__container" class="o365cs-base o365cst"
            [ngClass]="{
                'left-nav-offset': leftNavReact && !onWacContentPage,
                'appbar-offset': appBarEnabled && !onWacContentPage,
                'bottom-tray-navigation': bottomTrayEnabled,
                'ms-bgc-nla': !fluentThemeRefreshEnabled,
                'fluent-background-color': !fluentThemeRefreshEnabled,
                'fluentvnext-background': fluentThemeRefreshEnabled
            }">
            <ng-container *ngIf="showWorkspaceNav"
                      ohpLazyView
                      ngModulePath="workspace-nav#WorkspaceNavModule"></ng-container>
            <!-- This 'id' of 'officeHome__scroll-content' is referenced in 'fast-search-results.component' and they must be kept in sync -->
            <div id="officeHome__scroll-content" ohpScrollListener
                [ngClass]="{
                    'scroll-content': (!onContentPage),
                    'scroll-content--transform':!onContentPage && !onMyContentPage,
                    'app-gallery-workspace-nav-offset': showWorkspaceNav,
                    'scroll-content--hide': onSpacesPage
                }"
                (dragover)="dragoverHandler($event)"
                (drop)="dropHandler($event)"
                #scrollElement>
                <!--TODO: Account for pushing screen 48px to the right, affecting width-restrictors, mru columns, and restricted-width-media mixins-->
                <div id="officeHome__wrapper"
                    [ngStyle]="showBackgroundImage ? backgroundStyle : ''"
                    [ngClass]="{ 'fluent-background': showBackgroundImage }">
                    <div id="officeHome__content" (ohpResize)="onResize($event)">
                        <ng-container *ngIf="showMobileAppBanner" ohpLazyView ngModulePath="mobile-app-banner#MobileAppBannerModule"></ng-container>
                        <ng-container ohpLazyView *ngIf="!onContentPage && !onAppGallery && !onSpacesPage" ngModulePath="banner#BannerModule" [inputs]="{ viewMetric: viewMetric }"></ng-container>
                        <ohp-hero *ngIf="!onContentPage && !onSpacesPage && !onMyContentPage"></ohp-hero>
                        <ng-container ohpLazyView *ngIf="showNewUserShelf && (showNewUserShelfExpanded || showNewUserShelfCollapsed) && onHomePage" ngModulePath="new-user-shelf#NewUserShelfModule" [inputs]="{ collapsed: showNewUserShelfCollapsed }"></ng-container>
                        <ng-container *ngIf="webVitalsEnabled || memoryProfilingEnabled" ohpLazyView ngModulePath="web-vitals#WebVitalsModule"></ng-container>
                        <router-outlet></router-outlet>
                        <ng-container ohpLazyView ngModulePath="feature-tooltip-container#FeatureTooltipContainerModule"></ng-container>
                        <ng-container *ngIf="!mobileMenusEnabled" ohpLazyView ngModulePath="context-menu#ContextMenuModule"></ng-container>
                        <ng-container *ngIf="!mobileMenusEnabled && actionContextMenuEnabled" ohpLazyView ngModulePath="action-context-menu-react#ActionContextMenuReactModule"></ng-container>
                        <ng-container *ngIf="fluidSupportEnabled && !isIE" ohpLazyView ngModulePath="fluid-content#FluidContentModule" [inputs]="{ renderFluidDocument: onFluidContentPage }"></ng-container>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="loadFilePicker" ohpLazyView ngModulePath="file-picker-modal#FilePickerModalModule"></ng-container>
        <ng-container *ngIf="feedbackEnabled && !onWacContentPage && !(isStandalone | async) && !(isSearchPage && searchUXGeneralFeedbackEnabled)" ohpLazyView ngModulePath="feedback#FeedbackModule"></ng-container>
        <ng-container *ngIf="supportCentralEnabled && !onContentPage" ohpLazyView ngModulePath="support-central-react#SupportCentralReactModule"></ng-container>
        <ng-container *ngIf="uploadEnabled" ohpLazyView ngModulePath="upload-dialog#UploadDialogModule"></ng-container>
        <ng-container ohpLazyView ngModulePath="error-dialog#ErrorDialogModule"></ng-container>
        <ng-container ohpLazyView ngModulePath="input-dialog#InputDialogModule"></ng-container>
        <ng-container *ngIf="stayingAware" ohpLazyView ngModulePath="error-dialog-react#ErrorDialogReactModule"></ng-container>
        <ng-container *ngIf="spaces" ohpLazyView ngModulePath="create-spaces-dialog-react#CreateSpacesDialogReactModule"></ng-container>
        <ng-container *ngIf="taskModule" ohpLazyView ngModulePath="task-module-dialog-react#TaskModuleDialogReactModule"></ng-container>
        <ng-container *ngIf="spaces || customPivots" ohpLazyView ngModulePath="confirmation-dialog-react#ConfirmationDialogReactModule"></ng-container>
        <ng-container *ngIf="createOneNotePageEnabled" ohpLazyView ngModulePath="create-onenote-page-dialog-react#CreateOneNotePageDialogReactModule"></ng-container>
        <ng-container *ngIf="searchEnabled && !hideSearch" ohpLazyView ngModulePath="auto-suggest#AutoSuggestModule"
                      [inputs]="{
                        showFASTBreadcrumb: showFASTBreadcrumb
                      }">
        </ng-container>
        <ng-container ohpLazyView ngModulePath="side-popup-menu#SidePopupMenuModule"></ng-container>
        <ng-container *ngIf="toastContainer" ohpLazyView ngModulePath="toast-container-react#ToastContainerReactModule"></ng-container>
        <ohp-bottom-tray *ngIf="bottomTrayEnabled && !onFluidContentPage"></ohp-bottom-tray>
    </div>
    <ng-container ohpLazyView ngModulePath="first-run#FirstRunModule" *ngIf="firstRunEnabled || showPremiumUpsellModal"></ng-container>
    <ng-container ohpLazyView ngModulePath="banner#BannerModule"
            *ngIf="!onContentPage"
            [inputs]="{
                bottomAligned: true,
                viewMetric: viewMetric,
                bottomTrayEnabled: bottomTrayEnabled
            }">
    </ng-container>
    <ng-container *ngIf="mobileMenusEnabled" ohpLazyView ngModulePath="context-menu#ContextMenuModule"></ng-container>
    <ng-container *ngIf="mobileMenusEnabled || loadShareControlModuleForContentPage"
                  ohpLazyView
                  ngModulePath="share-control#ShareControlModule"
                  [inputs]="{
                      mobileShareMenu: mobileMenusEnabled,
                      contentShareMenu: loadShareControlModuleForContentPage
                  }">
    </ng-container>
    <ng-container *ngIf="loadMoveToFolderModuleForContentPage"
            ohpLazyView
            ngModulePath="move-to-folder-control#MoveToFolderControlModule"
            [inputs]="{
                mobileMoveToFolderMenu: mobileMenusEnabled,
                contentMoveToFolderMenu: loadMoveToFolderModuleForContentPage
            }">
    </ng-container>
    <ng-container *ngIf="nativeSearchEnabled" ohpLazyView ngModulePath="search-preload#SearchPreloadModule"></ng-container>
    <ng-container *ngIf="(wacHostEnabled | async)" ohpLazyView ngModulePath="wac-content#WacContentModule"></ng-container>
    <!-- TODO: Decide whether to lazy load -->
    <!-- <ohp-fluent-theme-provider *ngIf="fluentThemeRefreshEnabled"></ohp-fluent-theme-provider> -->
    <ng-container *ngIf="fluentThemeRefreshEnabled" ohpLazyView ngModulePath="fluent-theme-provider#FluentThemeProviderModule"></ng-container>
</div>
